// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"PredictionHeader_listContainer__3tcBy","listHeader":"PredictionHeader_listHeader__pqU83","listItem":"PredictionHeader_listItem__h3iZv"};